let initialState = {
  showReceiveInvite: false,
  employeeJoinModal: false,
  showStockIn: false,
  showQtyRevise: false,
  workflowApproveModal: false,
  downloadModal: false,
};
export default function modal(state = initialState, action) {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case 'OPEN_VERIFYPARTNER_MODAL':
      newState.showReceiveInvite = true;
      return newState;
    case 'CLOSE_VERIFYPARTNER_MODAL':
      newState.showReceiveInvite = false;
      return newState;
    case 'OPEN_EMPLOYEEJOIN_MODAL':
      newState.employeeJoinModal = true;
      return newState;
    case 'CLOSE_EMPLOYEEJOIN_MODAL':
      newState.employeeJoinModal = false;
      return newState;
    case 'OPEN_STOCKIN_MODAL':
      newState.showStockIn = true;
      return newState;
    case 'CLOSE_STOCKIN_MODAL':
      newState.showStockIn = false;
      return newState;
    case 'OPEN_QTY_REVISE_MODAL':
      newState.showQtyRevise = true;
      return newState;
    case 'CLOSE_QTY_REVISE_MODAL':
      newState.showQtyRevise = false;
      return newState;
    case 'OPEN_WORKFLOW_APPROVE_MODAL':
      newState.workflowApproveModal = true;
      return newState;
    case 'CLOSE_WORKFLOW_APPROVE_MODAL':
      newState.workflowApproveModal = false;
      return newState;
    case 'OPEN_DOWNLOAD_MODAL':
      newState.downloadModal = true;
      return newState;
    case 'CLOSE_DOWNLOAD_MODAL':
      newState.downloadModal = false;
      return newState;
    default:
      return newState;
  }
}
